import { httpClient } from "@/services";
// import { bonusChargeDefaultHeader, bonusChargeDefaultHeaderUser } from "@/pages/Accounting/BonusCharge/defaultHeader";
import { bonusChargeDefaultHeader_Account, bonusChargeDefaultHeader_User } from "@/pages/Accounting/BonusCharge/defaultHeader";

import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		bonusChargeList: [],
		bonusChargeFilter: null,
		bonusCharge: null,
		bonusChargePreloader: true
	},
	mutations: {
		updateBonusChargeList(state, { filter, rows, isDelete }) {
			if (!isDelete) state.bonusChargeList = rows;

			if (filter) {
				filter.filter_salary_month.reverse();
				state.bonusChargeFilter = filter;
			}

		},
		updateBonusCharge(state, payload) {
			state.bonusCharge = payload;
		},
		// updateBonusChargeListItem(state, payload) {
		// 	const { id, values } = payload;
		// 	console.log('%c [  id  ] ', 'color:#bada55', typeof id, id );
		// 	console.log('%c [  values  ] ', 'color:#bada55', typeof values, values );
		//
		// }
	},
	actions: {
		async getBonusCharge({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			const { data } = await httpClient.get('/bonus-charge');
			if (data && !data.status) {
				commit('updateBonusChargeList', data);
				commit('updateSettings', { settings: data.settings, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_Account });
				// commit('updateSettings', { settings: bonusChargeDefaultHeader_Account, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_Account });
			}

			dispatch("actionPreloader", false);
		},
		async getBonusChargeUser({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			const { data } = await httpClient.get('/bonus-charge');
			if (data && !data.status) {
				commit('updateBonusChargeList', data);
				// commit('updateSettings', { settings: data.settings, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_User });
				commit('updateSettings', { settings: bonusChargeDefaultHeader_User, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_User });
			}

			dispatch("actionPreloader", false);
		},
		async onBonusChargeSave({ dispatch, commit }, { id, ...values }) {
			dispatch("actionPreloader", true);
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/bonus-charge/${ id }` : '/bonus-charge';

			const { data } = await httpClient[typeOfRequest](url, values);
			// console.log('%c [  values  ] ', 'color:#bada55', typeof values, values );
			// console.log('%c [  data  ] ', 'color:#bada55', typeof data, data );
			if (data) {
				commit('updateBonusChargeListItem', { id, values });
			}
			dispatch("actionPreloader", false);
			return data;
		},
		async onBonusChargeSaveUser({ dispatch }, { id, ...values }) {
			dispatch("actionPreloader", true);
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/bonus-charge/${ id }` : '/bonus-charge';

			const { data } = await httpClient[typeOfRequest](url, values);
			// if (data && data.status) {
			// 	await dispatch("getBonusChargeUser");
			// }
			dispatch("actionPreloader", false);
			return data;
		},
		async onBonusChargeFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/bonus-charge/list', payload);
				if (data && !data.status) {
					commit('updateBonusChargeList', data);
					// commit('updateSettings', { settings: data.settings, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_Account });
					commit('updateSettings', { settings: bonusChargeDefaultHeader_Account, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_Account });
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onBonusChargeFilterUser({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/bonus-charge/list', payload);
				if (data && !data.status) {
					commit('updateBonusChargeList', data);
					// commit('updateSettings', { settings: data.settings, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_User });
					commit('updateSettings', { settings: bonusChargeDefaultHeader_User, key: requestKeys.BONUS_CHARGE, defaultHeader: bonusChargeDefaultHeader_User });
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onBonusChargeCreate({ commit }, id) {
			const url = id ? `/bonus-charge/create?department_id=${ id }` : "/bonus-charge/create";
			try {
				const { data } = await httpClient.get(url);
				if (data) {
					if (id) {
						return data;
					}
					commit('updateBonusCharge', data);

				}
			} catch (e) {
				console.error(e);
			}
		},
		async onRemoveBonusCharge({ dispatch }, item) {
			const { id, type, total, employee, department, salary_month } = item;
			try {
				await httpClient.delete(`/bonus-charge/${ id }`);
				dispatch('setAlert', {
					type: "success",
					message: `✅ Successfully added a <b>${ type }</b> 💰 of <b>${ total }</b> for <b>${ employee }</b> 👤 in the <b>${ department }</b> 🏢 department for <b>${ salary_month }</b> 📅.`
				});

			} catch (e) {
				console.error(e);
			}
		},
		async onBonusChargeEdit({ dispatch, commit }, id) {
			dispatch("actionPreloader", true);
			const { data } = await httpClient.get(`/bonus-charge/${ id }/edit`);
			if (data) {
				commit('updateBonusCharge', data);
			}
			dispatch("actionPreloader", false);
		},
	},
	getters: {
		bonusChargeList: s => s.bonusChargeList,
		bonusChargeFilter: s => s.bonusChargeFilter,
		bonusCharge: s => s.bonusCharge,
		bonusChargePreloader: s => s.bonusChargePreloader
	}

};
